import _ from 'lodash'

class NotificationService {

  constructor(storeProvided) {
    this.storeProvided = storeProvided
  }

  _getStore() {
    return this.storeProvided();
  }

  info (message, options = null) {
    const snotify = _.get(this._getStore(), ['$app', '$snotify'], null)
    snotify.info(message, options)
  }

  success (message, options = null) {
    const snotify = _.get(this._getStore(), ['$app', '$snotify'], null)
    snotify.success(message, options)
  }

  warning (message, options = null) {
    const snotify = _.get(this._getStore(), ['$app', '$snotify'], null)
    snotify.warning(message, options)
  }

  error (message, options = null) {
    const snotify = _.get(this._getStore(), ['$app', '$snotify'], null)
    snotify.error(message, options)
  }
}

export default NotificationService



// WEBPACK FOOTER //
// ./src/services/NotificationService.js